module.exports = __webpack_public_path__ + "static/media/beef-burger.dfd7c242.jpg";